const Grn = {

    // FIELDS
    "grn": "GRN",
    "goods_receipt_note": "Goods Receipt Note",
    "vendor": "Vendor",
    "item": "Item",
    "quantity": "Quantity",
    "received_date": "Received Date",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "GRN",
    "filter_title": "GRN Filter",
    "details_title": "GRN Details",
    
    // TABLE HEADER
    "table_vendor": "Vendor",
    "table_item": "Item",
    "table_quantity": "Quantity",
    "table_received_date": "Received Date",
    "table_status": "Status",
    
    // ERROR
    "error_vendor": "Select Vendor",
    "error_item": "Select Item",
    "error_quantity": "Enter Quantity",
    "error_received_date": "Select Received Date",
    "error_status": "Select Status",

}

export default Grn;

